import * as e from "react";
import a from "../lib/IconBase.es.js";
import i from "../defs/CaretCircleDoubleRight.es.js";
const o = e.forwardRef((r, t) => /* @__PURE__ */ e.createElement(a, { ref: t, ...r, weights: i }));
o.displayName = "CaretCircleDoubleRightIcon";
const m = o;
export {
  m as CaretCircleDoubleRight,
  o as CaretCircleDoubleRightIcon
};
